<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("project_period_setting.monthlyCycle") }}
        </h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project_period_setting.chargeStartDate") }}</label>
              <input
                type="number"
                class="form-control"
                v-model="monthly_calculate_period_start"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{ $t("project_period_setting.chargeEndDate") }}</label>
              <input
                type="number"
                class="form-control"
                v-model="monthly_calculate_period_end"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{ $t("project_period_setting.dataInputStartDate") }}</label>
              <input
                type="number"
                class="form-control"
                v-model="monthly_data_input_period_start"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{ $t("project_period_setting.dataInputEndDate") }}</label>
              <input
                type="number"
                class="form-control"
                v-model="monthly_data_input_period_end"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{ $t("project_period_setting.monthly_due_date") }}</label>
              <input
                type="number"
                class="form-control"
                v-model="monthly_due_date"
              /><br />
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          v-if="has_perm('update_project_setting') || GET_ACCOUNT_DATA.id == 1"
          @click="showMssgPeriod()"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </div>

    <div class="modal fade" id="modal-projectPeriod">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("ProjectGeneralSettings.project_seting_title") }}
            </h4>
          </div>
          <div class="modal-body">
            {{ $t("ProjectGeneralSettings.project_seting_msg") }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="savePeriodSettings"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils';

export default {
  name: "ProjectPeriodSettings",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      monthly_calculate_period_start: "",
      monthly_calculate_period_end: "",
      monthly_data_input_period_start: "",
      monthly_data_input_period_end: "",
      monthly_due_date: "",
      project_id: ""
    };
  },
  watch: {
    item: function() {
      this.initialize();
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SAVE_DEADLINESCONFIG",
      "SUCCESS_TOAST",
      "ERROR_TOAST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    initialize: function() {
      this.monthly_calculate_period_start = this.item.monthly_calculate_period_start;
      this.monthly_calculate_period_end = this.item.monthly_calculate_period_end;
      this.monthly_data_input_period_start = this.item.monthly_data_input_period_start;
      this.monthly_data_input_period_end = this.item.monthly_data_input_period_end;
      this.monthly_due_date = this.item.monthly_due_date;
      this.project_id = this.item.project_id;
    },
    showMssgPeriod() {
      $("#modal-projectPeriod").modal("show");
    },
    savePeriodSettings: function() {
      $("#modal-projectPeriod").modal("hide");
      this.waitingLoading(true);
      let data = {
        id: this.project_id,
        monthly_calculate_period_start: this.monthly_calculate_period_start,
        monthly_calculate_period_end: this.monthly_calculate_period_end,
        monthly_data_input_period_start: this.monthly_data_input_period_start,
        monthly_data_input_period_end: this.monthly_data_input_period_end,
        monthly_due_date: this.monthly_due_date
      };
      this.SAVE_DEADLINESCONFIG({ id: data.id, data: data })
        .then(
          function() {
            sessionStorage.setItem('projectMonthlyDueDate', this.monthly_due_date)
            sessionStorage.setItem('projectMonthlyCalculatePeriodStart', this.monthly_calculate_period_start)
            sessionStorage.setItem('projectMonthlyCalculatePeriodEnd', this.monthly_calculate_period_end)
            sessionStorage.setItem('projectMonthlyDataInputPeriodStart', this.monthly_data_input_period_start)
            sessionStorage.setItem('projectMonthlyDataInputPeriodEnd', this.monthly_data_input_period_end)
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    }
  },
  mounted() {
    this.initialize();
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Project/ProjectPeriodSettings.vue